import { createApp } from 'vue'
import App from './App.vue'
import axios from 'axios'

const app = createApp(App)

// 配置axios基础URL
axios.defaults.baseURL = process.env.NODE_ENV === 'production' 
  ? '/random-city-web/' 
  : '/'

app.mount('#app')
